export default __webpack_public_path__ + "static/media/twitter-hover.313206ca.svg";